import { UserState } from "store/user/types";

export function useIsInfluencer(user: UserState): boolean {
    return user.userInfo.Claims?.Details?.Roles.includes("Influencer");
}
